export default "__VITE_ASSET__DASRs5Sw__"